export default "__VITE_ASSET__D6rC1Rh5__"